/* eslint-disable @angular-eslint/component-selector */
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  SimpleChanges,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { IconsService } from '@libs/app.services/icons.service';
import { forEach } from 'lodash';
import { tap } from 'rxjs';
export type TColor =
  | 'text-color'
  | 'primary-color'
  | 'secondary-color'
  | 'accent-color'
  | 'background-color'
  | 'telegram-color';
@Component({
  selector: 'icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],

  imports: [CommonModule],
})
export class IconComponent implements OnChanges, AfterViewInit {
  element = viewChild<ElementRef>('element');
  name = input<string>();
  color = input<TColor>('text-color');
  size = input<string>('22');
  sub$;
  svg_data = signal<string>('');
  constructor(private iconsService: IconsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']?.previousValue !== changes['name']?.currentValue) {
      this.load();
    } else if (
      changes['color']?.previousValue !== changes['color']?.currentValue ||
      changes['size']?.previousValue !== changes['size']?.currentValue
    ) {
      this.onData(this.svg_data());
    }
  }
  ngAfterViewInit() {
    this.load();
  }
  private load() {
    this.sub$ = this.iconsService.load(this.name()).pipe(tap(svg => this.onData(svg)));
  }
  private onData(svg: string) {
    this.svg_data.set(svg);
    if (this.element && this.svg_data()) {
      this.element().nativeElement.innerHTML = this.svg_data();
      this.setColor();
      this.setSizeIfNotSet();
    }
  }
  private setColor() {
    const color = `var(--${this.color()})`;
    forEach(this.element().nativeElement.querySelectorAll('path') || [], svgElement => (svgElement.style.fill = color));
    this.svg.style.color = color;
  }
  private setSizeIfNotSet() {
    this.svg.setAttribute('width', this.size());
    this.svg.setAttribute('height', this.size());
  }
  get svg() {
    return this.element().nativeElement.querySelector('svg');
  }
}
